/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var NumericCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericCellModelExport, _super);
    function NumericCellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ae = 0;
        _this.af = 0;
        _this.ag = 0;
        return _this;
    }
    NumericCellModelExport.prototype.get_ac = function () {
        return "NumericCell";
    };
    NumericCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
        a.l("numericValue : " + this.ae + ", ");
        a.l("maxDecimalPlaces : " + this.af + ", ");
        a.l("minDecimalPlaces : " + this.ag + ", ");
    };
    NumericCellModelExport.$t = markType(NumericCellModelExport, 'NumericCellModelExport', CellModelExport.$);
    return NumericCellModelExport;
}(CellModelExport));
export { NumericCellModelExport };
//# sourceMappingURL=NumericCellModelExport.js.map
